<template>
    <templatePublicComponent>
        <div>
            <v-form v-model="valid" v-if="!requestSent" ref="form" lazy-validation>
                <v-container fluid grid-list-md>
                    <v-layout row wrap justify-space-between>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-model="editedItem.Name" label="Nom" :rules="requiredRules" required maxlength="100"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-model="editedItem.PhoneNumber" label="Téléphone/Cellulaire" :rules="requiredRules" required maxlength="10" return-masked-value mask="###-###-####"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-model="editedItem.AddressSnowRemoval" label="Adresse à déneiger" :rules="requiredRules" required maxlength="50"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-model="editedItem.Email" label="Courriel" :rules="emailRules" required maxlength="100"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <!-- Ville : Ste-Catherine (par défaut) -->
                            <v-combobox
                                v-model="editedItem.Town"
                                :items="townItems"
                                label="Ville"
                                :rules="requiredRules"
                                required
                            ></v-combobox>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-model="editedItem.PostalCode" label="CodePostal" :rules="requiredRules" required maxlength="7" return-masked-value mask="a#a-#a#"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <div style="text-align:center;">
                                <v-btn color="primary" style="margin-right:0px;margin-top:20px;" @click.native="send" :disabled="requestInProgress">Soumettre</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <div v-if="requestSent">
                Merci de votre soumission pour une demande de prix, notre équipe va vous contacter.
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
import APIHome from '@/api/home'

const APIService = new APIHome();

export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  },
  mounted() {
    this.$refs.form.resetValidation()
    this.editedItem.Town = this.townItems[0]
  },
  data() {
      return {
            requestSent: false,
            requestInProgress: false,
            valid: false,
            requiredRules: [
                (v) => !!v || 'Le champ est requis.',
            ],
            emailRules: [
                v => !!v || 'Le champ est requis.',
                v => /.+@.+/.test(v) || 'Le champ courriel est invalide.',
            ],
            editedItem: { Town: ''},
            townItems: ['Ste-Catherine']
      }
  },
  methods: {
      async send(){
          if (this.$refs.form.validate()) {
            await this.$recaptchaLoaded()
            this.$recaptcha('login').then((token) => {
                //console.log(token)
                this.editedItem.Token = token
                this.requestInProgress = true
                APIService.submitPriceRequest(this.editedItem).then(() => {
                    this.requestSent = true
                    this.requestInProgress = false
                  }
                )
            })

            this.$refs.form.resetValidation()
          }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/DemandePrix.vue